import React, { useState, useEffect } from 'react'
import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Chip, Rating } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'
import { axiosi } from '../config/axios'
import { useSelector } from 'react-redux'
import { selectLoggedInUser } from '../features/auth/AuthSlice'
import DeleteIcon from '@mui/icons-material/Delete'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'

export const ReviewManagementPage = () => {
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(false)
  const loggedInUser = useSelector(selectLoggedInUser)

  useEffect(() => {
    fetchReviews()
  }, [])

  const fetchReviews = async () => {
    try {
      setLoading(true)
      const response = await axiosi.get('/reviews')
      setReviews(response.data.data || response.data)
    } catch (error) {
      console.error('Fetch error:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleApprove = async (reviewId) => {
    try {
      await axiosi.patch(`/reviews/${reviewId}`, { approved: true }, {
        headers: { Authorization: `Bearer ${loggedInUser?.token}` }
      })
      fetchReviews()
    } catch (error) {
      console.error('Approve error:', error)
    }
  }

  const handleDelete = async (reviewId) => {
    if (window.confirm('Are you sure you want to delete this review?')) {
      try {
        await axiosi.delete(`/reviews/${reviewId}`, {
          headers: { Authorization: `Bearer ${loggedInUser?.token}` }
        })
        fetchReviews()
      } catch (error) {
        console.error('Delete error:', error)
      }
    }
  }

  return (
    <>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
          ⭐ Review Management
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: 'primary.main' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>User</TableCell>
                <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>Rating</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Comment</TableCell>
                <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>Media</TableCell>
                <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                <TableCell align="right" sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reviews.map((review) => (
                <TableRow key={review._id} hover>
                  <TableCell>{review.user?.name || 'Anonymous'}</TableCell>
                  <TableCell align="center">
                    <Rating value={review.rating} readOnly size="small" />
                  </TableCell>
                  <TableCell sx={{ maxWidth: '300px', wordBreak: 'break-word' }}>
                    {review.comment?.substring(0, 100)}...
                  </TableCell>
                  <TableCell align="center">
                    {review.photoUrls?.length > 0 && <Chip label={`📸 ${review.photoUrls.length}`} size="small" />}
                    {review.videoUrl && <Chip label="🎥 Video" size="small" sx={{ ml: 1 }} />}
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={review.approved ? 'Approved' : 'Pending'}
                      color={review.approved ? 'success' : 'warning'}
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="right">
                    {!review.approved && (
                      <Button
                        size="small"
                        variant="contained"
                        color="success"
                        startIcon={<ThumbUpIcon />}
                        onClick={() => handleApprove(review._id)}
                        sx={{ mr: 1 }}
                      >
                        Approve
                      </Button>
                    )}
                    <Button
                      size="small"
                      variant="contained"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={() => handleDelete(review._id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {reviews.length === 0 && !loading && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="textSecondary">No reviews found</Typography>
          </Box>
        )}
      </Container>
      <Footer />
    </>
  )
}
